const EventObjectClassEnum = Object.freeze({
    INVESTOR: 'INVESTOR',
    PROPOSAL: 'PROPOSAL',
    SHORTLIST: 'SHORTLIST'
});

export default EventObjectClassEnum;
